import React from 'react';

const SvgCalendar: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="calendar_svg__a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#calendar_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M16 2v4M8 2v4M3 9h18" />
        <rect width={18} height={17} rx={2} transform="translate(3 4)" />
        <path d="M7.013 12.729a.25.25 0 10.251.25.249.249 0 00-.251-.25M12.013 12.729a.25.25 0 10.251.25.249.249 0 00-.251-.25M17.013 12.729a.25.25 0 10.251.25.249.249 0 00-.251-.25M7.013 16.728a.25.25 0 10.251.25.25.25 0 00-.251-.25M12.013 16.728a.25.25 0 10.251.25.25.25 0 00-.251-.25" />
      </g>
    </svg>
  );
};

export default SvgCalendar;
